export default {
  __html: `<g fill="none" fill-rule="evenodd">
                <path fill="#201A5B" fill-rule="nonzero" d="M26.2 49.6c-2.5 0-4.8-1-6.5-2.7L1.5 28.6c-1.2-1.2-1.2-3.1 0-4.3 1.2-1.2 3.1-1.2 4.3 0L24 42.6c.6.6 1.4.9 2.2.9.8 0 1.6-.3 2.2-.9l18.3-18.3c1.2-1.2 3.1-1.2 4.3 0 1.2 1.2 1.2 3.1 0 4.3L32.7 46.9c-1.7 1.7-4 2.7-6.5 2.7z"/>
                <path fill="#201A5B" fill-rule="nonzero" d="M26.2 29.6c-1.7 0-3.1-1.4-3.1-3.1V3.9c0-1.7 1.4-3.1 3.1-3.1 1.7 0 3.1 1.4 3.1 3.1v22.6c0 1.7-1.4 3.1-3.1 3.1z"/>
                <path d="M-24.8-24.6H77.3V77.5H-24.8z"/>
            </g>`
}
